import { keyExists } from '../../../../utils';
import { tokens as T, operators } from './Lookup';
function isOperator(x) {
    return keyExists(operators, x);
}
export class Parser {
    Lexer;
    Terms;
    constructor(lexer) {
        this.Lexer = lexer;
        this.Terms = [];
        this.getAllTerms();
    }
    getTokens() {
        let token;
        do {
            token = this.Lexer.nextToken();
        } while (token.type !== T.EOF);
    }
    newTerm() {
        const term = { field: null, operator: null, value: null };
        this.Terms.unshift(term);
        return term;
    }
    getAllTerms() {
        this.getTokens();
        const tokens = this.Lexer.tokens.slice(0, -1);
        let term = this.newTerm();
        for (let i = tokens.length - 1; i >= 0; i--) {
            const { type, literal } = tokens[i];
            if (keyExists(this.Lexer.fieldNames, literal.toLowerCase())) {
                term.field = type;
                if (i > 0) {
                    term = this.newTerm();
                }
            }
            else if (isOperator(literal)) {
                term.operator = literal;
            }
            else if (term.value !== null) {
                term = this.newTerm();
            }
            else {
                term.value = literal;
            }
        }
    }
    getLastTerm() {
        return {
            term: this.Terms[this.Terms.length - 1],
            isFirstTerm: this.Terms.length === 1,
        };
    }
}
